import React, { Fragment } from "react";
import Select, { Async } from "react-select";
import { RadioGroup, Radio } from "react-radio-group";
import Dialog from "../../../components/dialog";
import Overlay from "../../../components/overlay";
import { getStores } from "../../../backend/stores";

export default function() {
  const {
    confirmDialogVisible,
    uploading,
    loading,
    machines,
    tools,
    m_faulty_list,
    t_faulty_list,
    store = { id: 0, name: "No store", use_app: 1 },
    reinspectionForm,
    docket_num_01,
    docket_num_02,
    docket_comment,
    request_docket_comment,
    request_docket_comment2,
    stand_condition,
    stand_condition_list,
    checkType
  } = this.state;
  const { match } = this.props;
  return (
    <div className="form comment_form_wrap">
      {!reinspectionForm && (
        <Fragment>
          <label htmlFor="store_search_input">Store</label>
          <Async
            id="store_search_input"
            loadOptions={ checkType ? getStores : undefined}
            value={store}
            onChange={checkType ? ({ value, label, use_app }) => {
              ()=> {this._setStore(value, label, use_app)}
            } : undefined }
          />
        </Fragment>
      )}
      { match.params.store_id && (
        <Fragment>
          <div className="form">
          {loading && <Overlay />}

          {match.params.store_id &&
            machines.map(
              (
                {
                  machine_id,
                  machine_code,
                  subject_id,
                  machine_status,
                  status,
                  last_inspection_date,
                  faulty_reason,
                  code,
                  faulty_list,
                  st
                }, index) => (
                  <div className="store-machines form" key={index}>
                    <label className={reinspectionForm ? "disabled m_t_label" : "m_t_label"}>
                      Machine Number: { reinspectionForm ? code : machine_code} { !reinspectionForm && (<span className={'status '+st}>{st}</span>)}
                    </label>
                    <label className={reinspectionForm ? "disabled" : ''}>
                      Inspection
                    </label>
                    
                    <RadioGroup
                      className={`radio-group ${reinspectionForm ? "disabled" : ''}`}
                      name={`machine-${machine_id || subject_id}`}
                      selectedValue={machine_status || status}
                      required="required"
                      onChange={
                        !reinspectionForm ? this._editMachine(index, "radio", "machine_status") : undefined
                      }
                    >
                      <div>
                        <Radio value={"Available"} /> <span>Passed</span>
                      </div>
                      <div>
                        <Radio value={"Faulty"} /> <span>Issue</span>
                      </div>
                      <div>
                        <Radio value={"Not Inspected"} /> <span>Not Inspected</span>
                      </div>
                    </RadioGroup>
                  
                  {( machine_status === "Faulty" || machine_status === "Issue" || (reinspectionForm && (status === "Faulty")) || (reinspectionForm && (status === "Issue")) ) ? (
                    <div key={index}>
                      <label className={reinspectionForm ? "disabled" : ''}>Equipment Fault</label>
                      
                      {!reinspectionForm ? (
                        <Fragment>
                          <Select name={`faulty-${machine_id || subject_id}`}
                            options={ !reinspectionForm && m_faulty_list}
                            onChange={
                              !reinspectionForm ? this._editMachine(index, "select", "faulty_reason") : undefined
                          }></Select>

                          {( (faulty_reason !== undefined && faulty_reason.other === 1) || (reinspectionForm && faulty_list.other === 1)) && [
                            <label className={reinspectionForm ? "disabled" : ''}>Please provide a brief description of the fault</label>,
                            <textarea
                            onChange={!reinspectionForm ? this._editMachine(index, "input", "faulty_reason_text") : undefined}
                            />
                          ]}
                        </Fragment>
                      ) : (
                          <textarea className={reinspectionForm ? "disabled" : ''} value={ faulty_list !== null ? (JSON.parse(faulty_list)).text : '' } />
                      )}
                    </div>
                  ) : null}
                </div>
              )
            )}
          {match.params.store_id &&
            tools.map(
              (
                {
                  tool_id,
                  tool_code,
                  subject_id,
                  tool_status,
                  status,
                  last_inspection_date,
                  faulty_list,
                  faulty_reason,
                  code,
                  st
                }, index) => (
                <div className="store-machines tools form" key={index}>
                  <label className={reinspectionForm ? "disabled m_t_label" : "m_t_label"}>
                    Tool Number: { reinspectionForm ? code : tool_code} {!reinspectionForm && (<span className={'status '+st}>{st}</span>)}
                  </label>
                  <label className={reinspectionForm ? "disabled" : ''}>
                    Merchandiser Inspection
                  </label>
                  <RadioGroup
                    className={`radio-group ${reinspectionForm ? "disabled" : ''}`}
                    name={`tool-${tool_id || subject_id}`}
                    selectedValue={tool_status || status}
                    onChange={
                      !reinspectionForm ? this._editTool(index, "radio", "tool_status") : undefined
                    }
                  >
                    <div>
                      <Radio value={"Available"} /> <span>Passed</span>
                    </div>
                    <div>
                      <Radio value={"Faulty"} /> <span>Issue</span>
                    </div>
                    <div>
                      <Radio value={"Not Inspected"} /> <span>Not Inspected</span>
                    </div>
                  </RadioGroup>
                  { (tool_status === "Faulty" || tool_status === "Issue" || (reinspectionForm && status === "Faulty")  || (reinspectionForm && status === "Issue")) ? (
                    <div>
                      <label className={reinspectionForm ? "disabled" : ''}>Equipment Fault</label>
                      {!reinspectionForm ? (
                        <Fragment>
                          <Select name={`faulty-${tool_id || subject_id}`}
                              options={t_faulty_list}
                              onChange={
                                !reinspectionForm ? this._editTool(index, "select", "faulty_reason") : undefined
                            }></Select>
                          {faulty_reason !== undefined && faulty_reason.other === 1 && [
                            <label className={reinspectionForm ? "disabled" : ''}>Please provide a brief description of the fault</label>,
                            <textarea
                            onChange={!reinspectionForm ? this._editTool(index, "input", "faulty_reason_text") : undefined }
                            />
                          ]}
                        </Fragment>
                        ) : (
                          <textarea className={reinspectionForm ? "disabled" : ''} value={ faulty_list !== null ? (JSON.parse(faulty_list)).text : '' } />
                        )}
                    </div>
                  ) : null}
                </div>
              )
            )}
            {/* store use_app == 0 ? hide fields about dockets */}
            {store.use_app === 0 && (
            <Fragment>
              <label className={reinspectionForm ? "disabled label_docket" : "label_docket"}>Are booking sheets required?</label>
              <RadioGroup
                className={`radio-group ${reinspectionForm ? "disabled" : '' }`}
                name={"sheet_required"}
                selectedValue={this.state.sheet_required }
                onChange={
                  !reinspectionForm ? this._change("sheet_required", 1, 0) : undefined
                }
              >
                <div>
                  <Radio value={1} /> <span>Yes</span>
                </div>
                <div>
                  <Radio value={0} /> <span>No</span>
                </div>
              </RadioGroup>

              <label className={reinspectionForm ? "disabled" : ''}>
                Is there a spare hire book in store?
              </label>
              <RadioGroup
                className={`radio-group ${reinspectionForm && "disabled"}`}
                name={"spare_hire_book"}
                selectedValue={this.state.spare_hire_book }
                onChange={
                  !reinspectionForm ? this._change("spare_hire_book", 1, 0) : undefined
                }
              >
                <div>
                  <Radio value={1} /> <span>Yes</span>
                </div>
                <div>
                  <Radio value={0} /> <span>No</span>
                </div>
              </RadioGroup>
              {this.state.spare_hire_book === 0 && [
                <label className={reinspectionForm ? "disabled" : ''}>Is a new book required?</label>,
                <RadioGroup
                  className={`radio-group ${reinspectionForm && "disabled"}`}
                  name={"new_book_required"}
                  selectedValue={this.state.new_book_required}
                  onChange={
                    !reinspectionForm ? this._change("new_book_required", 1, 0) : undefined
                  }
                >
                  <div>
                    <Radio value={1} /> <span>Yes</span>
                  </div>
                  <div>
                    <Radio value={0} /> <span>No</span>
                  </div>
                </RadioGroup>
              ]}
              <label className={reinspectionForm ? "disabled" : ''}>Hire dockets collected (in sequence)</label>
            <RadioGroup className={`radio-group ${reinspectionForm ? "disabled" : ''}`}
                name={"hire_docket_collected"}
                selectedValue={this.state.hire_docket_collected }
                onChange={
                  !reinspectionForm ? this._change("hire_docket_collected", 1, 0) : undefined
                }
              >
                <div>
                  <Radio value={1} /> <span>Yes</span>
                </div>
                <div>
                  <Radio value={0} onClick={ !reinspectionForm ? this._emptyDocket : undefined} /> <span>No</span>
                </div>
              </RadioGroup>
              { this.state.hire_docket_collected === 1 ? (
                <div className="docket-container">
                  <input className={reinspectionForm ? "disabled" : ''} name={"docket_num_01"} value={reinspectionForm ? docket_num_01 : this.state.docket_num_01}
                    onChange={event => 
                      this.setState({ docket_num_01: event.target.value })
                    }
                  />
                  to{" "}
                  <input className={reinspectionForm ? "disabled" : ''} name={"docket_num_02"} value={reinspectionForm ? docket_num_02 : this.state.docket_num_02}
                    onChange={event =>
                      this.setState({ docket_num_02: event.target.value })
                    }
                  />
                </div>
              ) : (
                <Fragment>
                  <label className={reinspectionForm ? "disabled" : ''}>Why were the dockets not in sequence?</label>
                  <textarea name={"docket_comment"}
                    value={reinspectionForm ? docket_comment : this.state.docket_comment}
                      onChange={event =>
                        this.setState({ docket_comment: event.target.value })
                      }
                    />
                </Fragment>
              ) }

              <label className={reinspectionForm ? "disabled" : ''}>Have Rug Doctor requested additional dockets?</label>
              <RadioGroup
                className={`radio-group ${reinspectionForm && "disabled"}`}
                name={"request_docket"}
                selectedValue={this.state.request_docket}
                onChange={
                  !reinspectionForm ? this._change("request_docket", 1, 0) : undefined
                }
              >
                <div>
                  <Radio value={1} /> <span>Yes</span>
                </div>
                <div>
                  <Radio value={0} /> <span>No</span>
                </div>
              </RadioGroup>
              {this.state.request_docket === 1 &&
                (<Fragment>
                  <label className={reinspectionForm ? "disabled" : ''}>Hire dockets requested</label>
                  <textarea name={"request_docket_comment"}
                  value={reinspectionForm ? request_docket_comment : this.state.request_docket_comment}
                    onChange={event =>
                      this.setState({ request_docket_comment: event.target.value })
                    }
                  />
                  <label className={reinspectionForm ? "disabled" : ''}>How were the dockets sent to Rug Doctor</label>
                  <textarea name={"request_docket_comment2"}
                  value={reinspectionForm ? request_docket_comment2 : this.state.request_docket_comment2}
                    onChange={event =>
                      this.setState({ request_docket_comment2: event.target.value })
                    }
                  />
                  </Fragment>
                )
              }

            </Fragment>
            )}
            {/* // store use_app == 0 ? hide fields about dockets */}

            <label className={reinspectionForm ? "disabled" : "label_stand"}>Stand condition</label>
            {!reinspectionForm ? (
              <Select name={"stand_condition"} options={stand_condition_list}
                onChange={event =>
                  this.setState({ stand_condition: event.value })
              }></Select>
            ) : (
              <input disabled="disabled" value={stand_condition} />
            )}

            { this.state.stand_condition === 'Other' && [
              <label className={reinspectionForm && "disabled"}>Please provide a brief description of the stand condition</label>,
              <textarea
              value={this.state.stand_note}
              onChange={event =>
                !reinspectionForm ? this.setState({ stand_note: event.target.value }) : undefined
              }
              />
            ]}
            <label className={reinspectionForm ? "disabled" : ''}>Alert Rug Doctor</label>
            <RadioGroup
              className={`radio-group ${reinspectionForm && "disabled"}`}
              name={"alert"}
              selectedValue={this.state.alert}
              onChange={!reinspectionForm ? this._change("alert", 1, 0) : undefined
              }
            >
              <div>
                <Radio value={1} /> <span>Yes</span>
              </div>
              <div>
                <Radio value={0} /> <span>No</span>
              </div>
            </RadioGroup>
            
            <label className={reinspectionForm ? "disabled" : ''}>Additional comments</label>
            <textarea
              value={this.state.inspection_note}
              className={reinspectionForm ? "disabled" : ''}
              onChange={!reinspectionForm ? this._change("inspection_note") : undefined}
            />

          
          {reinspectionForm && (
            <Fragment>
            <label>Action completed?</label>
            <RadioGroup
              className="radio-group"
              name={"complete"}
              selectedValue={this.state.complete}
              onChange={this._change("complete", true, false)}
            >
              <div>
                <Radio value={true} /> <span>Yes</span>
              </div>
              <div>
                <Radio value={false} /> <span>No</span>
              </div>
            </RadioGroup>
            <label>Note</label>
            <textarea
              value={this.state.added_note}
              onChange={this._change("added_note")}
            />
            </Fragment>)
          }

          <button disabled={!this._valid()} onClick={this._toggleConfirmDialog}>
            Save
          </button>
          {confirmDialogVisible && (
            <Dialog close={this._toggleConfirmDialog}>
              <div>
                <h4>You are completing the action.</h4>
                <p>
                  This will notify RugDoctor that the action has been completed.
                  This inspection will no longer be editable
                </p>
                <div className="button-group">
                  <button onClick={this._toggleConfirmDialog}>No</button>
                  <button
                    onClick={() => {
                      this._toggleConfirmDialog();
                      this._upload();
                    }}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </Dialog>
          )}
        </div>
        </Fragment>
        )}
        {uploading && <Dialog loader />}
      
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/stores/comment-form/view.js